import React, {ChangeEvent, useRef} from 'react';
import {FormControlLabel, Radio, RadioGroup, Typography} from '@mui/material';
import {ControlledRadioGroupProps} from './types';

function ControlledRadioGroup<T>({
	value,
	onChange,
	radioOpts,
	ariaLabelledBy = 'radio-buttons-group',
	direction = 'column',
	gap,
	forceTextPrimaryColor = false,
	error,
}: ControlledRadioGroupProps<T>) {
	const radioRef = useRef<HTMLDivElement | null>();

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange(event);
		if (radioRef) {
			radioRef.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
		}
	};

	return (
		<RadioGroup
			sx={{
				marginLeft: 1.5,
				flexDirection: direction,
				alignItems: 'flex-start',
				gap,
			}}
			aria-labelledby={ariaLabelledBy}
			value={value}
			onChange={handleChange}>
			{radioOpts.map(radio => (
				<FormControlLabel
					key={radio.label}
					ref={radioRef}
					value={radio.value}
					control={
						<Radio
							color={error ? 'error' : 'primary'}
							sx={error ? {color: theme => theme.palette.error.main} : undefined}
						/>
					}
					label={
						forceTextPrimaryColor ? (
							<Typography color="text.primary">{radio.label}</Typography>
						) : (
							radio.label
						)
					}
					data-tag-id={radio.dataTagId}
				/>
			))}
		</RadioGroup>
	);
}

export {ControlledRadioGroup};
